import React, {useState} from 'react';
import LessonPlanPage1 from './PlanPage1';
import LessonPlanPage2 from './PlanPage2';
import LessonPlanPage3 from './PlanPage3';
import LessonPlanPage4 from './PlanPage4';

const LessonPlan = () => {
  const [page, setPage] = useState(1);
  const [showInfo, setShowInfo] = useState(!localStorage.getItem('alertedLessonPlan@quiz-client'));
  const [showInfo2, setShowInfo2] = useState(!localStorage.getItem('alertedLessonPlan2@quiz-client'));

  return (
    <div className="LessonPlan mt-4">
      {showInfo && (
        <div className="alert alert-info text-center">
          <div>
            В древе отображены главные темы грамматики казахского языка.
            <br />
            Цель: показать из каких элементов состоит казахский язык.
          </div>
          <button
            onClick={() => {
              setShowInfo(false);
              localStorage.setItem('alertedLessonPlan@quiz-client', true);
            }}
            type="button"
            className="btn btn-light btn-sm mt-2"
          >
            <span>Закрыть</span>
          </button>
        </div>
      )}
      {!showInfo && showInfo2 && (
        <div className="alert alert-info text-center">
          <div>
            Темы обозначены звездами в соответствии с важностью
            <br />5 звезд: критически важно знать для передачи мысли
            <br />
            1-2 звезды: для передачи мысли можно обойтись без них, но важно понимать их в речи собеседника По мере
            прохождения уроки будут отображаться в древе зеленой галочкой
            <br />
            Некоторые темы изучаются в двух или более уроках
          </div>
          <button
            onClick={() => {
              setShowInfo2(false);
              localStorage.setItem('alertedLessonPlan2@quiz-client', true);
            }}
            type="button"
            className="btn btn-light btn-sm mt-2"
          >
            <span>Закрыть</span>
          </button>
        </div>
      )}
      <div className="row gx-2 gx-lg-4 gy-2 justify-content-center">
        <div className="col-auto">
          <button onClick={() => setPage(1)} className={`btn btn-sm btn-${page === 1 ? 'primary' : 'secondary'}`}>
            1 страница
          </button>
        </div>
        <div className="col-auto">
          <button onClick={() => setPage(2)} className={`btn btn-sm btn-${page === 2 ? 'primary' : 'secondary'}`}>
            2 страница
          </button>
        </div>
        <div className="col-auto">
          <button onClick={() => setPage(3)} className={`btn btn-sm btn-${page === 3 ? 'primary' : 'secondary'}`}>
            3 страница
          </button>
        </div>
        <div className="col-auto">
          <button onClick={() => setPage(4)} className={`btn btn-sm btn-${page === 4 ? 'primary' : 'secondary'}`}>
            4 страница
          </button>
        </div>
      </div>
      <div className="mt-5 text-center">
        {page === 1 && <LessonPlanPage1 />}
        {page === 2 && <LessonPlanPage2 />}
        {page === 3 && <LessonPlanPage3 />}
        {page === 4 && <LessonPlanPage4 />}
      </div>
    </div>
  );
};

export default LessonPlan;
